import { GETNEW, POSTNEW, EXPORTNEW, POSTFormDataImport } from '@/request/http'

// 获取批次列表
export const getBatchConfigList = p => POSTNEW('/studentv2/dictionary/batch/page', p, 4)

// 删除批次
export const deleteBatchConfig = p => POSTNEW('/studentv2/dictionary/batch/remove', p, 4)

// 新增批次
export const addBatchConfig = p => POSTNEW('/studentv2/dictionary/batch/save', p, 4)

// 编辑批次
export const editBatchConfig = p => POSTNEW('/studentv2/dictionary/batch/update', p, 4)

// 导入批次
export const importBatchConfigTable = p => POSTFormDataImport('/studentv2/dictionary/batch/import', p, 4)

// 导出批次
export const exportBatchConfigTable = p => EXPORTNEW('/studentv2/dictionary/batch/export', p, 4)

// 获取考生类别列表
export const getCandidateTypeConfigList = p => POSTNEW('/studentv2/dictionary/candidateType/page', p, 4)

// 删除考生类别
export const deleteCandidateTypeConfig = p => POSTNEW('/studentv2/dictionary/candidateType/remove', p, 4)

// 新增考生类别
export const addCandidateTypeConfig = p => POSTNEW('/studentv2/dictionary/candidateType/save', p, 4)

// 编辑考生类别
export const editCandidateTyConfig = p => POSTNEW('/studentv2/dictionary/candidateType/update', p, 4)

// 导入考生类别
export const importCandidateTypeTable = p => POSTFormDataImport('/studentv2/dictionary/candidateType/import', p, 4)

// 导出考生类别
export const exporCandidateTypeTable = p => EXPORTNEW('/studentv2/dictionary/candidateType/export', p, 4)

// 获取外国语种列表
export const getLanguageConfigList = p => POSTNEW('/studentv2/dictionary/language/page', p, 4)

// 删除外国语种
export const deleteLanguageConfig = p => POSTNEW('/studentv2/dictionary/language/remove', p, 4)

// 新增外国语种
export const addLanguageConfig = p => POSTNEW('/studentv2/dictionary/language/save', p, 4)

// 编辑外国语种
export const editLanguageConfig = p => POSTNEW('/studentv2/dictionary/language/update', p, 4)

// 导入外国语种
export const importLanguageTable = p => POSTFormDataImport('/studentv2/dictionary/language/import', p, 4)

// 导出外国语种
export const exportLanguageTable = p => EXPORTNEW('/studentv2/dictionary/language/export', p, 4)

// 获取录取结果列表
export const getAdmissionResultConfigList = p => POSTNEW('/studentv2/dictionary/admissionResult/page', p, 4)

// 删除录取结果
export const deleteAdmissionResultConfig = p => POSTNEW('/studentv2/dictionary/admissionResult/remove', p, 4)

// 新增录取结果
export const addAdmissionResultConfig = p => POSTNEW('/studentv2/dictionary/admissionResult/save', p, 4)

// 编辑录取结果
export const editAdmissionResultConfig = p => POSTNEW('/studentv2/dictionary/admissionResult/update', p, 4)

// 导入录取结果
export const importAdmissionResultTable = p => POSTFormDataImport('/studentv2/dictionary/admissionResult/import', p, 4)

// 导出录取结果
export const exportAdmissionResultTable = p => EXPORTNEW('/studentv2/dictionary/admissionResult/export', p, 4)

// 获取院系列表
export const getFacultyConfigList = p => GETNEW('/studentv2/faculty/page', p, 4)

// 删除院系
export const deleteFacultyConfig = p => POSTNEW('/studentv2/faculty/remove', p, 4)

// 新增院系
export const addFacultyConfig = p => POSTNEW('/studentv2/faculty/saveByFacultyId', p, 4)

// 编辑院系
export const editFacultytConfig = p => POSTNEW('/studentv2/faculty/updateByFacultyId', p, 4)

// 导入院系
export const importFacultyTable = p => POSTFormDataImport('/studentv2/faculty/importFacultyInfo', p, 4)

// 导出院系
export const exportFacultyTable = p => EXPORTNEW('/studentv2/faculty/export', p, 4)

// 获取专业列表
export const getMajorConfigList = p => POSTNEW('/studentv2/facAndMaj/page', p, 4)

// 删除专业
export const deleteMajorConfig = p => POSTNEW('/studentv2/major/remove ', p, 4)

// 新增专业
export const addMajorConfig = p => POSTNEW('/studentv2/major/saveByMajorId', p, 4)

// 编辑专业
export const editMajorConfig = p => POSTNEW('/studentv2/major/updateByMajorId', p, 4)

// 导入专业
export const importMajorTable = p => POSTFormDataImport('/studentv2/major/importMajorInfo', p, 4)

// 导出专业
export const exportMajorTable = p => EXPORTNEW('/studentv2/major/export', p, 4)

// 获取毕业类别列表
export const getGraduateTypeConfigList = p => POSTNEW('/studentv2/dictionary/graduateType/page', p, 4)

// 删除毕业类别
export const deleteGraduateTypeConfig = p => POSTNEW('/studentv2/dictionary/graduateType/remove', p, 4)

// 新增毕业类别
export const addGraduateTypeConfig = p => POSTNEW('/studentv2/dictionary/graduateType/save', p, 4)

// 编辑毕业类别
export const editGraduateTypeConfig = p => POSTNEW('/studentv2/dictionary/graduateType/update', p, 4)

// 导入毕业类别
export const importGraduateTypeTable = p => POSTFormDataImport('/studentv2/dictionary/graduateType/import', p, 4)

// 导出毕业类别
export const exportGraduateTypeTable = p => EXPORTNEW('/studentv2/dictionary/graduateType/export', p, 4)

// 获取政治面貌列表
export const getPoliticalStatusConfigList = p => POSTNEW('/studentv2/dictionary/politicalStatus/page', p, 4)

// 删除政治面貌
export const deletePoliticalStatusConfig = p => POSTNEW('/studentv2/dictionary/politicalStatus/remove', p, 4)

// 新增政治面貌
export const addPoliticalStatusConfig = p => POSTNEW('/studentv2/dictionary/politicalStatus/save', p, 4)

// 编辑政治面貌
export const editPoliticalStatusConfig = p => POSTNEW('/studentv2/dictionary/politicalStatus/update', p, 4)

// 导入政治面貌
export const importPoliticalStatusTable = p => POSTFormDataImport('/studentv2/dictionary/politicalStatus/import', p, 4)

// 导出政治面貌
export const exportPoliticalStatusTable = p => EXPORTNEW('/studentv2/dictionary/politicalStatus/export', p, 4)

// 获取省市列表
export const getProvinceAndCitiesConfigList = p => POSTNEW('/studentv2/dictionary/provinceAndCities/page', p, 4)

// 删除省市
export const deleteProvinceAndCitiesConfig = p => POSTNEW('/studentv2/dictionary/provinceAndCities/remove', p, 4)

// 新增省市
export const addProvinceAndCitiesConfig = p => POSTNEW('/studentv2/dictionary/provinceAndCities/save', p, 4)

// 编辑省市
export const editProvinceAndCitiesConfig = p => POSTNEW('/studentv2/dictionary/provinceAndCities/update', p, 4)

// 导入省市
export const importProvinceAndCitiesTable = p => POSTFormDataImport('/studentv2/dictionary/provinceAndCities/import', p, 4)

// 导出省市
export const exportProvinceAndCitiesTable = p => EXPORTNEW('/studentv2/dictionary/provinceAndCities/export', p, 4)

// 获取地区列表
export const getAreaConfigList = p => POSTNEW('/studentv2/dictionary/area/page', p, 4)

// 删除地区
export const deleteAreaConfig = p => POSTNEW('/studentv2/dictionary/area/remove', p, 4)

// 新增地区
export const addAreaConfig = p => POSTNEW('/studentv2/dictionary/area/save', p, 4)

// 编辑地区
export const editAreaConfig = p => POSTNEW('/studentv2/dictionary/area/update', p, 4)

// 导入地区
export const importAreaTable = p => POSTFormDataImport('/studentv2/dictionary/area/import', p, 4)

// 导出地区
export const exportAreaTable = p => EXPORTNEW('/studentv2/dictionary/area/export', p, 4)

// 获取民族列表
export const getNationConfigList = p => POSTNEW('/studentv2/nation/page', p, 4)

// 删除民族
export const deleteNationConfig = p => POSTNEW('/studentv2/nation/remove', p, 4)

// 新增民族
export const addNationConfig = p => POSTNEW('/studentv2/nation/save', p, 4)

// 编辑民族
export const editNationConfig = p => POSTNEW('/studentv2/nation/update', p, 4)

// 导入民族
export const importNationTable = p => POSTFormDataImport('/studentv2/nation/importNationInfo', p, 4)

// 导出民族
export const exportNationTable = p => EXPORTNEW('/studentv2/nation/export', p, 4)

// 获取学生性质列表
export const getNatureConfigList = p => POSTNEW('/studentv2/dictionary/studentNature/page', p, 4)



// WEBPACK FOOTER //
// ./src/api/modules/configuration.js